import { Yup } from '@minecraft.utils';

export default Yup;
